import { FieldArray } from 'formik';
import { BrokerReferralFields } from '../BrokerReferralForm';
import { KeyboardEvent, useState } from 'react';

const isValidEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const ContactsField = () => {
  const [inputValue, setInputValue] = useState('');

  return (
    <FieldArray name={BrokerReferralFields.addtl_contacts}>
      {({ push, remove, form }) => {
        const handleAddEmail = () => {
          if (isValidEmail(inputValue.trim())) {
            push(inputValue.trim());
            setInputValue('');
          }
        };

        return (
          <div className="col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Additional Contacts
            </label>

            <div className="mt-1 flex flex-wrap gap-2 rounded-md border-gray-300 shadow-sm focus-within:border-indigo-500 focus-within:ring-indigo-500">
              {form.values.addtl_contacts.map(
                (email: string, index: number) => (
                  <span
                    key={index}
                    className="inline-flex items-center gap-1 bg-indigo-100 text-indigo-700 rounded-md px-2 py-0.5 text-sm"
                  >
                    {email}
                    <button
                      type="button"
                      onClick={() => remove(index)}
                      className="hover:text-indigo-900"
                    >
                      ×
                    </button>
                  </span>
                )
              )}

              <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                  if (e.key === 'Enter' || e.key === ',') {
                    e.preventDefault();
                    handleAddEmail();
                  } else if (e.key === 'Tab' && inputValue.trim()) {
                    e.preventDefault();
                    handleAddEmail();
                  } else if (
                    e.key === 'Backspace' &&
                    inputValue === '' &&
                    form.values.addtl_contacts.length > 0
                  ) {
                    remove(form.values.addtl_contacts.length - 1);
                  }
                }}
                onBlur={handleAddEmail}
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                placeholder="Enter email addresses..."
              />
            </div>
          </div>
        );
      }}
    </FieldArray>
  );
};
